import {REGULAR_SIZE} from '@hconnect/common/consts'
import {type EventType} from '@hconnect/common/types'
import {Grid, SxProps, Typography} from '@mui/material'
import React from 'react'

import {EventTypeLabel} from './EventTypeLabel'

type TagProps = {
  eventType: EventType
  eventTypeLabelPrefix?: string
  sx?: SxProps
  'data-test-id'?: string
}

export const EventTypeTag: React.FC<TagProps> = ({
  eventType,
  'data-test-id': dataTestId,
  eventTypeLabelPrefix,
  sx
}) => {
  return (
    <Grid item {...REGULAR_SIZE} sx={{pl: {xs: 0}, width: '100%', whiteSpace: 'pre-line', ...sx}}>
      <Typography variant="h4" color="textPrimary">
        <EventTypeLabel
          eventType={eventType}
          eventTypeLabelPrefix={eventTypeLabelPrefix}
          data-test-id={dataTestId}
        />
      </Typography>
    </Grid>
  )
}
